import { onAuthStateChanged } from 'firebase/auth';
import axios from 'utils/axios';
import { auth } from '../../../firebase';
import { v4 as uuidv4 } from 'uuid';

/**
 * Lists every agent in a simulation — the seller first, then each buyer:
 * `[{ agentConversationId, name, email, role }]`.
 */
const getSimulationAgents = (simulationId, callback, errorCallback) => {
  return async (dispatch) => {
    try {
      let unsubscribe = onAuthStateChanged(auth, async (user) => {
        const token = await user?.getIdToken();
        const reqId = uuidv4();
        try {
          const response = await axios.get(
            `/ads/admin/simulations/${simulationId}/agents`,
            {
              params: {
                'request-id': reqId,
              },
              headers: {
                Authorization: `Bearer ${token}`,
              },
            },
          );
          if (response.status === 200) {
            if (typeof callback === 'function') callback(response?.data || []);
          } else {
            if (typeof errorCallback === 'function')
              errorCallback('Failed to fetch simulation agents');
          }
        } catch (e) {
          if (typeof errorCallback === 'function')
            errorCallback(
              e?.response?.data?.message || 'Failed to fetch simulation agents',
            );
        }
        unsubscribe();
      });
    } catch (e) {
      if (typeof errorCallback === 'function')
        errorCallback('Failed to fetch simulation agents');
    }
  };
};

export default getSimulationAgents;
